import { useEffect, useMemo, useState } from 'react';

import { useGetUser, useQueryOktaInfo } from 'app/api/hooks/core/v1/auth/user';
import { useGetBeamerSegments } from 'app/api/hooks/core/v1/beamer';
import { useGetRelationships, useGetUnclaimedRelationships } from 'app/api/hooks/core/v1/payee/payeeRelationships';
import { useGetCanadianProvinceList } from 'app/hooks/i18n/states/useGetCanadianProvinceList';

import { BeamerUserDto } from './types';

export const useGetBeamerUserDto = () => {
  const [userId, setUserId] = useState<null | string>(null);

  const user = useGetUser();

  const {
    data: beamerSegmentData,
  } = useGetBeamerSegments();

  const canadaProvinceList = useGetCanadianProvinceList();

  const {
    data: claimedRelationshipData,
  } = useGetRelationships();

  const {
    data: unclaimedRelationshipData,
  } = useGetUnclaimedRelationships();

  const {
    data: oktaLoginType,
    isSuccess: oktaLoginTypeIsSuccess,
  } = useQueryOktaInfo();

  useEffect(() => {
    setUserId(user?.id ?? null);
  },
  [user, oktaLoginType]);

  return useMemo<BeamerUserDto | null>(() => {
    if (userId && oktaLoginTypeIsSuccess) {
      const beamerDto: BeamerUserDto = {
        beamerSegments: beamerSegmentData?.segments ?? [],
        canadaProvinceList,
        claimedRelationships: claimedRelationshipData?.payeeRelationships ?? [],
        oktaInfo: oktaLoginType ?? null,
        unclaimedRelationships: unclaimedRelationshipData?.payeeRelationships ?? [],
        user,
      };

      return beamerDto;
    }

    return null;
    // dont add canadaProvinceList here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    beamerSegmentData,
    claimedRelationshipData?.payeeRelationships,
    oktaLoginType,
    oktaLoginTypeIsSuccess,
    unclaimedRelationshipData?.payeeRelationships,
    user,
    userId,
  ]);
};
